export default {
  'ReviewsFilter.positive': 'Позитивные',
  'ReviewsFilter.negative': 'Негативные',
  'ReviewsFilter.topicsFilter': 'Все топики',
}
